import { useEffect, useRef, useState } from 'react';
import ProfileMenu from '../profileMenu/profileMenu';
import { connect, useSelector } from 'react-redux';
import { signOut } from '../../redux/user/user.async-thunks';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircleUserRound, Home } from 'lucide-react';
import { RootState } from 'src/redux/redux-store';
import { setUserStateActiveClient } from 'src/redux/user/user.slice';
import { Button } from '../ui/button';

interface DashboardMenubarProps {
  readonly bgColorClass?: string;
  readonly imageUrl?: string;
  readonly showHomeButton?: boolean;
}

export const DashboardMenubar = ({ bgColorClass = '', imageUrl, showHomeButton = false }: DashboardMenubarProps) => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const activeClient = useSelector((state: RootState) => state.userState.activeClient);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleAvatarClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleSwitchSeatsClick = () => {
    dispatch(setUserStateActiveClient(undefined));
    navigate('/client/seats');
  };

  const handleProfileClick = () => {
    if (activeClient) {
      navigate(`/client/account`);
    } else {
      const accountPath = search.includes('404=t') ? '/account?404=t' : '/account';
      navigate(accountPath);
    }
  };

  const handleLogoutClick = async() => {
    await dispatch(signOut() as any);
    navigate('/login');
  };

  useEffect(() => {
    const handler = (event: MouseEvent) => {
      const target = event.target as Node | null;
      if (target && !menuRef.current?.contains(target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className={`left-0 top-0 flex w-full items-center justify-between p-4 ${bgColorClass}`}>
      {showHomeButton && (
        <Button
          variant="white"
          size="icon"
          className="bg-gray-200"
          onClick={() => navigate('/surveys')}
          asChild
        >
          <Home
            strokeWidth={1.5}
            className="size-7 cursor-pointer"
          />
        </Button>
      )}
      <div
        className="flex items-center gap-2"
        ref={menuRef}
      >
        <CircleUserRound
          strokeWidth={1.5}
          className="size-8 font-normal cursor-pointer"
          onClick={handleAvatarClick}
        />
        <div className="relative" >
          {isMenuOpen && (
            <ProfileMenu
              onProfileClick={handleProfileClick}
              onLogoutClick={handleLogoutClick}
              onSwitchSeatsClick={handleSwitchSeatsClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const connector = connect(null, { signOut });

export default connector(DashboardMenubar);
